import { RdProject } from '@neo.tax/rd/hooks';

export enum RdProjectEligibilityQuestionnaireAnswer {
  YES = 'YES',
  NO = 'NO',
}

type Question = {
  text: string;
  shortText: string;
  YesResult: Partial<RdProject>;
  NoResult: Partial<RdProject>;
  Reset: Partial<RdProject>;
};

export const Questions: Question[] = [
  {
    text: "Did substantially all (i.e., greater than 80%) of this project's work involve technical uncertainties, as well as processes of experimentation to overcome those technical uncertainties?",
    shortText: 'Technical uncertainties and experimentation',
    YesResult: { isTechnicallyUncertain: true },
    NoResult: { isTechnicallyUncertain: false },
    Reset: { isTechnicallyUncertain: null },
  },
  {
    text: "Was this project's development process undertaken to create or improve customer-facing or customer-using components?",
    shortText: 'Customer-facing development',
    YesResult: { isCustomerFacingDevelopment: true },
    NoResult: { isCustomerFacingDevelopment: false },
    Reset: { isCustomerFacingDevelopment: null },
  },
  {
    text: 'Was the project highly innovative, did it involve significant economic risk, and was the functionality not commercially available for purchase, lease, or license?',
    shortText: 'Innovative, risky, and not commercially available',
    YesResult: { isInnovativeAndRisky: true },
    NoResult: { isInnovativeAndRisky: false },
    Reset: { isInnovativeAndRisky: null },
  },
];
